<template>
  <div class="page">
    <div class="m-content">
      <div class="m-title">
        <img src="@/assets/img/home/21698910070_ 1.png" alt="">
        <div class="m-des">
          <p>湖北省高校成人学士学位外语考试</p>
          <!--<p>华夏慕课（湖北) 网络技术有限公司</p>-->
          <span>请选择您的学位授予单位报名！</span>
        </div>
      </div>
      <div class="m-box">
        <div class="m-box-nav" v-for="(item,index) in list" :key="index" @click="goTo(item.studentDomain,item.offTenant)">
          <img :src="item.logoImage" alt="">
          <p>{{item.name}}</p>
          <!--<em :style="'background:'+item.styleName" class="m-em"></em>-->
          <!--遮挡页面-->
          <!--<div v-show="item.isShow" class="m-cover">-->
            <!--<p>暂未<br/>开通</p>-->
          <!--</div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Dialog } from 'vant';
  export default {
    components: {},
    data () {
      return {
        list:[
//          {
//            iconPath: require('@/assets/img/home/Maskgroup.png'),
//            name:'武汉大学',
//            styleName:'#01503A',
//            jumpUrl:'https://10486.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/Maskgroup1.png'),
//            name:'华中师范大学',
//            styleName:'#014C59',
//            jumpUrl:'https://10511.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/Maskgroup2.png'),
//            name:'中国地质大学',
//            styleName:'#014C59',
//            jumpUrl:'https://10491.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/Maskgroup3.png'),
//            name:'华中农业大学',
//            styleName:'#08733B',
//            jumpUrl:'https://10504.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/Maskgroup4.png'),
//            name:'湖北大学',
//            styleName:'#057750',
//            jumpUrl:'https://10512.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/Maskgroup5.png'),
//            name:'湖北理工学院',
//            styleName:'#A1241E',
//            jumpUrl:'https://10920.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/image34.png'),
//            name:'湖北中医药大学 ',
//            styleName:'#036475',
//            jumpUrl:'https://10507.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/image36.png'),
//            name:'武汉轻工大学',
//            styleName:'#186DA2',
//            jumpUrl:'https://10496.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/image501.png'),
//            name:'湖北警官学院',
//            styleName:'#111A41',
//            jumpUrl:'https://11332.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/image44.png'),
//            name:'湖北美术学院',
//            styleName:'#1A4483',
//            jumpUrl:'https://10523.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/bszssd.png'),
//            name:'湖北民族大学',
//            styleName:'#224A79',
//            jumpUrl:'https://10517.hbdee.com',
//            isShow:false,
//          },
//          {
//            iconPath: require('@/assets/img/home/image45.png'),
//            name:'湖北工程学院',
//            styleName:'#1548B5',
//            jumpUrl:'https://10528.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/image46.png'),
//            name:'荆楚理工学院',
//            styleName:'#755665',
//            jumpUrl:'https://11336.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/image47.png'),
//            name:'武汉东湖学院',
//            styleName:'#04602D',
//            jumpUrl:'https://11798.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/image48.png'),
//            name:'武昌理工学院',
//            styleName:'#B02A21',
//            jumpUrl:'https://12310.hbdee.com',
//            isShow:true,
//          },
//          {
//            iconPath: require('@/assets/img/home/image49.png'),
//            name:'武汉工商学院',
//            styleName:'#2F7436',
//            jumpUrl:'https://13242.hbdee.com',
//            isShow:true,
//          },
        ]
      }
    },
    created () {
      this.getDataList()
    },
    methods: {
      goTo(i,y){
        if(y!=1){
          Dialog.alert({
            title: '提示',
            message: '暂未开通！',
          }).then(() => {

          })
        }else {
          window.location.href = 'https://'+i
        }
      },
      getDataList(){
        this.http.getRequest({
          url: 'app/userInfo/findTenantList',
          msg: {},
          success: (res) => {
            this.list = res
          }
        })
      }
    },
    mounted () {

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/less" lang="less" scoped>
  .page {
    background: #F4F6F9 url("../../assets/img/home/MaskBg.png") no-repeat 0 0;
    background-size: 100% auto;
    .m-content{
      background: #ffffff;
      padding: 23px 16px 20px 16px;
      position: absolute;
      left:12px;
      right: 12px;
      top:35px;
      bottom: 0;
      border-radius: 4px 4px 0 0;
      overflow-y: auto;
      .m-title{
        display: flex;
        align-items: center;
        >img{
          width: 35px;
          height: 35px;
          margin-right: 11px;
        }
        .m-des{
          >p{
            font-size: 13px;
            color: #333333;
            margin-bottom: 6px;
          }
          >span{
            font-size: 13px;
            color: #666666;
          }
        }
      }
      .m-box{
        margin-top: 35px;
        display: flex;
        gap:24px;
        flex-wrap: wrap;
        .m-box-nav{
          width: 90px;
          box-shadow: 2px 2px 10px 0px rgba(0,0,0,0.1);
          border-radius: 9px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 8px 0 10px 0;
          position: relative;
          >img{
            width: 50px;
            height: 50px;
            margin-bottom: 10px;
          }
          >p{
            font-size: 12px;
            color: #000000;
            text-align: center;
            margin-top: 10px;
          }
          .m-em{
            width: 21px;
            height: 4px;
            border-radius: 5px ;
            margin-top: 10px;
          }
          .m-cover{
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: rgba(0,0,0,0.3);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            >p{
              font-size: 14px;
              font-weight: bold;
              margin: auto;
              color: #ffffff;
            }
          }
        }
      }
    }
  }
</style>

